import styled from "styled-components";

// header {
// display: flex;
// flex-direction: column;
// justify-content: center;
// align-items: center;
// background-color: #005ca7;
//   }
//   .title {
// /* background-color: #f49100; */
// border-top: 45px solid #f49100;
// border-left: 40px solid transparent;
// border-right: 40px solid transparent;
// height: 0px;
// position: relative;
// top: 45px;
// width: fit-content;
//   }
//   .title p {
// margin-top: -40px;
// font-size: 28px;
// color: white;
// font-weight: 700;
// font-family: sans-serif;
//   }
//   header img {
//     width: 100%;
//     max-width: 450px;
//     min-width: 320px;
//   }
//   .logo {
//     height: 55px;
//   }

export const Header = styled.header(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#005ca7",
}));

export const Logo = styled.div(() => ({
  height: "55px",
  img: {
    width: "100%",
    maxWidth: "450px",
    minWidth: "320px",
  },
}));

export const Title = styled.div(() => ({
  borderTop: "45px solid #f49100",
  borderLeft: "40px solid transparent",
  borderRight: "40px solid transparent",
  height: "0px",
  position: "relative",
  top: "45px",
  width: "fit-content",
  p: {
    marginTop: "-40px",
    fontSize: "28px",
    color: "white",
    fontWeight: "700",
  },
  "@media (max-width: 438px)": {
    p: {
      fontSize: "20px",
      marginTop: "-35px",
    },
  },
}));

export const TitlePersonalData = styled(Text)(() => ({
  textTransform: "none",
}));
